<template>
  <header :class="{'empty': isHeaderEmpty}">
    <div id="header-logo">
      <a href="/">
        <img src="../../assets/img/logos/bow-text.svg" alt="Bow">
      </a>
    </div>

    <HeaderSearchInput id="header-search"></HeaderSearchInput>

    <div id="header-user-infos">
      <template v-if="authenticated">
        <div>
          <router-link to="/preferences">
            {{ this.user.login }}
          </router-link>
          <SimpleLink @click="logout" class="link--icon-only">
            <i class="icon-logout icon"></i>
          </SimpleLink>
        </div>
        <div id="since">
          bow user since {{ new Date(this.user.creationdate).getFullYear() }}
        </div>
      </template>
      <template v-else>
        <router-link to="/login">Login</router-link>
      </template>
    </div>

  </header>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import HeaderSearchInput from '@/components/layout/HeaderSearchInput'
import SimpleLink from '@/components/common/SimpleLink.vue'

@Component({
  name: 'Header',
  props: [
    'route'
  ],
  components: {
    HeaderSearchInput,
    SimpleLink
  }
})
class Header extends Vue {
  @Prop route

  logout() {
    this.$fetch
      .delete(`/users/${this.user.id}/auth`)
      .then(() => this.$storage.delete('bow-user'))
      .then(() => this.$router.push({ name: 'Login' }))
  }

  get isHeaderEmpty() {
    return this.route == '/login';
  }
}

export default Header
</script>

<style scoped lang="less">
@import '../../assets/less/globals';
header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: white;
  border-bottom: 1px solid var(--color-separation-border);
}

#header-logo,
#header-search,
#header-user-infos {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--header-height);
  padding: var(--margin--small) var(--margin--medium);
}

#header-logo {
  img {
    vertical-align: bottom;
  }
}

#header-search {
  flex-grow: 2;
}

#header-user-infos {
  flex-direction: column;
  align-items: flex-start;

  & > div {
    display: flex;
    align-items: center;
  }

  .link--icon-only {
    padding-top: 0;
    padding-bottom: 0;

    font-size: 22px;
  }
}

header.empty {
  justify-content: center;
  background-color: var(--color-bg-sidebar);

  #header-logo {
    text-align: center;
    animation: reveal-down 1s ease;

    img {
      filter: brightness(0) invert(1);
    }
  }

  #header-search,
  #header-user-infos {
    display: none;
  }
}

#since {
  font-size: 75%;
  color: var(--color-grey);
}

#header-search {
  width: 100%;
  padding: 20px;

  background: #CCC;
  border-left: 1px solid var(--color-separation-border);
  border-right: 1px solid var(--color-separation-border);
}

@media screen and (min-width: @screen-desktop-low) {
  header {
    flex-direction: row;

    height: var(--header-height);
  }

  #header-search {
    padding: 0;

    background: transparent;
  }
}
</style>
